module.exports = __webpack_public_path__ + "static/media/icon-settings-strip-icon.1ccacf68.svg";